module.exports = __webpack_public_path__ + "img/mobile.5b891602.png";